// extracted by mini-css-extract-plugin
module.exports = {"collection-preview":"collection-preview_collection-preview__1EuCJ","title":"collection-preview_title__1g1Ak","preview":"collection-preview_preview__3w-SW"};